import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EditTemplateStoreFeatureKey} from './edit-template-store.config';
import {EditTemplateState} from './edit-template-store.reducer';


export const selectEditTemplateState = createFeatureSelector<EditTemplateState>(EditTemplateStoreFeatureKey);

export const selectTemplate = createSelector(
  selectEditTemplateState,
  (state) => state?.template
);

export const selectLoading = createSelector(
  selectEditTemplateState,
  state => state?.loading
);

export const selectError = createSelector(
  selectEditTemplateState,
  state => state?.error
);

export const selectTemplateRoute = createSelector(
  selectEditTemplateState,
  state => state?.routeState
);

/*Legal hub*/
export const selectLegalHubFilters = createSelector(
    selectEditTemplateState,
    state => state?.legalHub?.filters ?? null
)

export const selectedLegalHubPlaybook = createSelector(
    selectEditTemplateState,
    state => state?.legalHub?.selectedPlaybook ?? null
)

export const rightBarHigherZindex = createSelector(
    selectEditTemplateState,
    state => state?.rightBarHigherZindex ?? false
)